/** Rules for which tool steps of a promoted workflow run without supervisor approval. */

import type { BlueprintToolStep } from './types';

/** The ids that run unattended after one step is switched. */
export const nextPreApproved = (steps: BlueprintToolStep[], stepId: string, on: boolean): string[] => {
  const current = steps.filter((step) => step.preApproved).map((step) => step.stepId);
  return on ? [...new Set([...current, stepId])] : current.filter((id) => id !== stepId);
};

/** Reads and writes are told apart by risk: a high-risk step changes something. */
export const isWriteStep = (step: BlueprintToolStep): boolean => step.riskLevel === 'high';
